import { AvatarColor, AvatarSize } from "./Avatar.types";

export const AVATAR_SIZE_VARIANTS: Record<AvatarSize, string> = {
  xs: "h-4 w-4",
  sm: "h-6 w-6 text-2xs",
  md: "h-8 w-8 text-sm",
  lg: "h-10 w-10 text-sm",
  xl: "h-15 w-15",
};

export const AVATAR_COLOR_VARIANTS: Record<AvatarColor, string> = {
  primary: "bg-[rgb(27,62,159)]",
  secondary: "bg-[rgb(134,15,134)]",
};
